import { Fragment } from "react";

import { ChannelCell } from "./ChannelCell";
import { FinanceGridRow } from "./FinanceGridRow";
import type { IFinanceGridChannel } from "./types";
import { entryStatus } from "./utils";

/** Rend toutes les lignes d'un canal : prix actuels/à venir, ligne vide si aucun prix, et historique replié. */
export const ChannelRows = ({
    channel,
    isHistoryOpen,
    onToggleHistory,
}: {
    channel: IFinanceGridChannel;
    isHistoryOpen: boolean;
    onToggleHistory: () => void;
}) => {
    const visible = channel.entries.filter((e) => entryStatus(e) !== "past");
    const past = channel.entries.filter((e) => entryStatus(e) === "past");

    return (
        <Fragment>
            {channel.entries.length === 0 && (
                <tr className="border-b border-border-color last:border-b-0">
                    <td className="py-1.5 px-3 align-middle">
                        <ChannelCell channel={channel} />
                    </td>
                    <td className="py-1.5 px-3 align-middle text-right">
                        <span className="text-sm text-foreground">—</span>
                    </td>
                    <td colSpan={4} />
                </tr>
            )}
            {visible.map((entry, i) => (
                <FinanceGridRow
                    key={entry.id}
                    channel={channel}
                    entry={entry}
                    isFirstOfChannel={i === 0}
                    pastCount={past.length}
                    isHistoryOpen={isHistoryOpen}
                    onToggleHistory={onToggleHistory}
                />
            ))}
            {isHistoryOpen &&
                past.map((entry) => (
                    <FinanceGridRow
                        key={entry.id}
                        channel={channel}
                        entry={entry}
                        isFirstOfChannel={visible.length === 0}
                        pastCount={past.length}
                        isHistoryOpen={isHistoryOpen}
                        onToggleHistory={onToggleHistory}
                    />
                ))}
        </Fragment>
    );
};
